import {
  Input,
  Output,
  OnDestroy,
  Component,
  EventEmitter,
} from '@angular/core';
import { OrderByValues } from './order-by-values';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-sortable-column',
  styleUrls: ['./sortable-column.component.scss'],
  templateUrl: './sortable-column.component.html',
})
export class SortableColumnComponent implements OnDestroy {
  @Input() readonly sortBy: string;
  @Input() column: string;
  @Input() title: string;
  @Input() orderAscending: boolean;
  @Output() orderBy = new EventEmitter<OrderByValues>();

  icon = AppIcon;
  iconSize = AppIconSize;
  iconColor = AppIconColor;

  ngOnDestroy(): void {
    this.orderBy.complete();
  }

  setSortBy(): void {
    const orderAscending = this.sortBy === this.column ? !this.orderAscending : true;
    this.orderBy.emit({
      orderBy: this.column,
      orderAscending,
    });
  }
}
